import { Component } from '@angular/core';
import { AddLeadModalComponent } from '../modal/add-lead-modal/add-lead-modal.component';
import { UploadFileModalComponent } from '../modal/upload-file-modal/upload-file-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LeadsService } from '../service/lead.service';
import { HttpService } from '../https.service';
import { URLUtils } from '../urlUtils';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationComponent } from '../modal/confirmation/confirmation.component';
import { UpdateStatusModalComponent } from '../modal/update-status-modal/update-status-modal.component';
import { NgxSpinnerService } from "ngx-spinner";
import { AddNotesModalComponent } from '../modal/add-notes-modal/add-notes-modal.component';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';

@Component({
  selector: 'app-leads-list',
  templateUrl: './leads-list.component.html',
  styleUrls: ['./leads-list.component.css']
})
export class LeadsListComponent {
  leads: any[] = [];
  filteredLeads: any[] = [];
  searchTerm: string = '';
  currentPage: number = 1;
  itemsPerPage: number = 10;
  uid:any;
  isValidUid = false;
  leadNotes: Map<string, string> = new Map();
  leadId:any;
  isReverse:boolean=false;
  selectedMatter: string = "entity";
  specializations = [
    'Criminal Law', 
    'Civil Law', 
    'Corporate Law', 
    'Family Law', 
    'Immigration Law', 
    'IP Law',
    'Tax Law',
    'Real Estate Law',
    'Banking Law',
    'Other'
  ];
  searchTermChanged = new Subject<string>();
  lastLeadId: any = null;  // Track the last item's ID
  totalLeads: number = 0;
  departmentsMap:any[]=[];
  plan = 'paid'
  constructor(private leadsService: LeadsService, private route: ActivatedRoute, private modalService: NgbModal, 
       private httpService: HttpService, private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit():void {
    this.searchTermChanged.pipe(
      debounceTime(300),      // wait 300ms after the last keystroke
      distinctUntilChanged()  // only if the text is different
    ).subscribe(term => {
      this.currentPage = 1;  // RESET to first page

      if (term.trim()) {
        this.getLeadSearch(term);
      } else {
        // Optionally fetch all leads again or clear the list
        this.getLeads();  // assuming you have a method to get all
        this.fetchLeadsLimit();
      }
    });

    // this.route.queryParamMap.subscribe((params:any) => {
    //   this.uid = params.get('uid');
    //   // this.isValidUid = !!this.uid; // Set to true if UID exists, false otherwise
    //   console.log('User ID:', this.uid);
    // });

    // this.leadsService.getLeads().subscribe(leads => {
    //   this.leads = leads;
    //   this.filteredLeads = leads;
    // });

    // this.spinner.show(); //show the spinner for 3sec
    // setTimeout(() => {
    //   this.spinner.hide();
    // }, 3000); // Hide after 3 seconds

    if (window.location.pathname == '/leads') {
      this.selectedMatter='entity';
    }

    this.getLeads();
    this.fetchLeadsLimit();  
    this.getDept();
    //console.log('leads', this.filteredLeads)
  }
  
  getDept() {
    const uid = localStorage.getItem('profuid');
    this.httpService.sendReGetRequest(URLUtils.getDepartment(uid)).subscribe((res: any) => {
      const departments = res.data || [];

      // Populate the departmentsMap and specializations array
      this.departmentsMap = [];
      this.specializations = departments.map((dept: any) => {
        this.departmentsMap[dept.id] = dept.name;
        return dept.name === 'I am not sure' ? 'Other' : dept.name;
      });

      //console.log('Departments:', this.specializations);
    });
  }

  getLeads() {
    this.spinner.show();
    this.httpService.sendGetRequest(URLUtils.leadslawyers()).subscribe((response: any) => {
      //console.log(response.data);
      this.spinner.hide();
      this.leads = response.data.reverse();
      this.filteredLeads = response.data;
    });
  }

  fetchLeadsLimit() {
    this.spinner.show();
    this.httpService.sendGetRequest(URLUtils.getLeadLimit(this.itemsPerPage))
      .subscribe((response: any) => {
        this.spinner.hide();
        this.leads = response.data;
        this.filteredLeads = response.data;
        
        // Track last item's ID for next page request
        if (response.data.length > 0) {
          this.lastLeadId = response.data[response.data.length - 1].id;
        }
  
        // Optionally store total count if available
        if (response.total) {
          this.totalLeads = response.total;
        }
      });
  }

  fetchNextLeads() {
    //console.log('lastLeadId',this.lastLeadId)
    //if (!this.lastLeadId) return;  // No more leads to fetch
  
    this.spinner.show();
    this.httpService.sendGetRequest(URLUtils.getNCLeadLimit(this.itemsPerPage, this.lastLeadId))
      .subscribe((response: any) => {
        this.spinner.hide();
        const newLeads = response.data;
  
        if (newLeads.length > 0) {
          // Append to current list
          this.leads = [...this.leads, ...newLeads];
          this.filteredLeads = [...this.filteredLeads, ...newLeads];
          // Update last lead ID
          this.lastLeadId = newLeads[newLeads.length - 1].id;
        } else {
          // No more leads to fetch
          console.log('No more leads');
        }
      });
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.getTotalPages()) {
      this.currentPage = page;
      this.fetchNextLeads();      
      // console.log('currentPage',this.currentPage)
      // console.log('itemsPerPage',this.itemsPerPage)
      // console.log('this.leads.length',this.leads.length)

      // const totalLoadedPages = Math.ceil(this.leads.length / this.itemsPerPage);
      // console.log('ccc',totalLoadedPages)
      // Check: if the new page needs data that isn't loaded yet
      // if (page > totalLoadedPages) {
      //   console.log(`Need to load page ${page}, current loaded pages: ${totalLoadedPages}`);
      //   this.fetchNextLeads();
      // } else {
      //   console.log(`Page ${page} is already loaded`);
      // }
    }
  }
  
  
  getDisplaySubcategory(subs: string[]): string {
    return subs
      .map(spec => this.specializations.includes(spec) ? spec : 'Other')
      .join(', ');
  }  

  openAddLeadModal() {
    const modalRef = this.modalService.open(AddLeadModalComponent, { 
      centered: true,
      size: 'lg',
      backdrop: 'static',    // disables closing on outside click
      keyboard: false,  
    });
    
    modalRef.result.then((result) => {
      if (result) {
        this.leadsService.addLead(result);
        this.getLeads();
      }
    }, (reason) => {
      // Modal dismissed
    });
  }
  
  openUploadFileModal() {
    const modalRef = this.modalService.open(UploadFileModalComponent, { 
      centered: true,
      size: 'lg'
    });
    
    modalRef.result.then((result) => {
      this.getLeads();
      if (result && Array.isArray(result)) {
        this.leadsService.importLeadsFromCSV(result);
      }
    }, (reason) => {
      // Modal dismissed
    });
  }

  confirmDelete(id: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      centered: true,
      backdrop: 'static',    // disables closing on outside click
      keyboard: false,       // disables closing on ESC
      size: 'sm'
    });
  
    // Pass the ID to the modal component
    modalRef.componentInstance.leadId = id;
  
    modalRef.result.then((result) => {
      if (result === 'deleted') {
       // this.toast.success('Lead lawyer deleted successfully')
        this.getLeads(); // Refresh leads list after deletion
      }
    }, (reason) => {
      // Modal dismissed
    });
  }

  deleteLead(id:any) {
    this.httpService.sendDeleteRequest(URLUtils.deleteLeads(id)).subscribe((response: any) => {
      this.getLeads();
    });
  }

  search() {
    if (!this.searchTerm.trim()) {
      this.filteredLeads = this.leads;
      return;
    }
    
    const term = this.searchTerm.toLowerCase();
    this.filteredLeads = this.leads.filter(lead => 
      lead.name.toLowerCase().includes(term) || 
      lead.email.toLowerCase().includes(term) ||
      lead.category.toLowerCase().includes(term)
    );
  }

  viewLeadDetails(lead: any) {
    //console.log('pass lead', lead)
    this.router.navigate(['/leads', lead.id]);
    this.leadsService.setLead(lead);
  }

  SubscriptionDetails(lead:any){
    if(this.plan=='free'){
        this.router.navigate(['/subscription-view'],{
          queryParams:{
            name: lead.category === 'entity' ? lead.name : lead.fullname,
            email: lead.email,
          }
        })
    }
    else{
      this.router.navigate(['plan-details'],{
        queryParams:{
          name: lead.category === 'entity' ? lead.name : lead.fullname,
          email: lead.email,
        }
      })
    }
    
  }

  
  openUpdateStatusModal(lead: any): void {
    // Implementation for opening update status modal
    //console.log('Open update status modal for lead', lead);
    const modalRef = this.modalService.open(UpdateStatusModalComponent, {
      centered: true,
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
    });
    
    // Pass lead data to modal
    modalRef.componentInstance.lead = { ...lead };
    modalRef.componentInstance.isQuery = false; //update the modal val.
    
    modalRef.result.then((result) => {
      if (result) {
        this.getLeads();
        // If lead was updated, refresh the list
        // this.leadsService.getLeadlist().subscribe((leads:any) => {
        //   this.leads = leads;
        //   this.search(); // Apply current search filter
        // });
      }
    }, (reason) => {
      // Modal dismissed
    });
  }

  addNotesModal(lead:any){
    const modalRef = this.modalService.open(AddNotesModalComponent, {
      centered: true,
      size: 'md',
      backdrop: 'static',    // disables closing on outside click
      keyboard: false,  
    });
    
    modalRef.componentInstance.lead = { ...lead };
    
    modalRef.result.then((result) => {
      if (result) {
        this.getLeads();
        this.leadNotes.set(lead.id, result.notes);
        //console.log('Notes added for lead:', lead.id, result.notes);
        
        const updatedLead = this.leads.find(l => l.id === lead.id);
        if (updatedLead) {
          updatedLead.hasNotes = true;
        }
      }
    }, (reason) => {
      // Modal dismissed
    });
  }

  getPaginatedLeads() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.filteredLeads.slice(startIndex, endIndex);
  }
  
  getTotalPages() {
    return Math.ceil(this.filteredLeads.length / this.itemsPerPage);
  }
  getPageNumbers(): number[] {
    const totalLoadedPages = Math.ceil(this.filteredLeads.length / this.itemsPerPage);
    return Array.from({ length: totalLoadedPages }, (_, i) => i + 1);
  }
  
  
  // getTotalPages() {
  //   return Math.ceil(this.filteredLeads.length / this.itemsPerPage);
  // }
  
  // getPageNumbers() {
  //   const totalPages = this.getTotalPages();
  //   return Array.from({ length: totalPages }, (_, i) => i + 1);
  // }
  
  // changePage(page: number) {
  //   if (page >= 1 && page <= this.getTotalPages()) {
  //     this.currentPage = page;
  //   }
  // }
  
  getPaginationRange() {
    const start = (this.currentPage - 1) * this.itemsPerPage + 1;
    const end = Math.min(start + this.itemsPerPage - 1, this.filteredLeads.length);
    return `${start}-${end} of ${this.filteredLeads.length} items`;
  }

  //sorting func!!
  sortingFile(key: string) {
    this.isReverse = !this.isReverse;
  
    this.filteredLeads = this.filteredLeads?.sort((a: any, b: any) => {
      const valA = this.getSortableValue(a, key).toLowerCase();
      const valB = this.getSortableValue(b, key).toLowerCase();
  
      if (valA < valB) return this.isReverse ? 1 : -1;
      if (valA > valB) return this.isReverse ? -1 : 1;
      return 0;
    });
  }
  
  getSortableValue(obj: any, key: string): any {
    switch (key) {
      case 'name':
        return obj.category === 'entity' ? obj.name || '' : obj.fullname || '';
      case 'subcategory':
        return (obj.subcategory && obj.subcategory[0]) || '';
      default:
        return obj[key] || '';
    }
  }
  
  onClick(value: string) {
    this.selectedMatter = value;
    //this.selectedMatter=='legalmatter'?this.router.navigate(['/matter/legalmatter/'+this.selectedValue]):this.router.navigate(['/matter/generalmatter/'+this.selectedValue]);
  }

  onSearchChange() {
    this.searchTermChanged.next(this.searchTerm);
  }

  getLeadSearch(a:any) {
    this.spinner.show();
    this.httpService.sendGetRequest(URLUtils.searchLeads(a)).subscribe((response: any) => {
      this.spinner.hide();
      console.log(response.data);
      this.leads = response.data
      this.filteredLeads = response.data;
    });
  }

}